import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useTranslation } from 'react-i18next';
import { Stats } from '../../commons/stats/stats';
import { useOwnStats } from '../../hooks/use-own-stats';
export const OwnStats = ({ country }) => {
    const { t } = useTranslation();
    const { data: ownStats } = useOwnStats(country);
    const stats = ownStats[0];
    return (_jsx(Stats, { stats: [
            {
                id: 'your-rank',
                title: t('menuGenerator.table.top10.stats.label.rank'),
                value: t(`menuGenerator.table.top10.stats.values.${(stats === null || stats === void 0 ? void 0 : stats.ranking) ? 'rank' : 'withoutRank'}`, {
                    rank: stats === null || stats === void 0 ? void 0 : stats.ranking,
                }),
            },
            {
                id: 'total-menus',
                title: t('menuGenerator.table.top10.stats.label.totalMenus'),
                value: t('menuGenerator.table.top10.stats.values.totalMenus', { totalMenus: stats === null || stats === void 0 ? void 0 : stats.total }),
            },
            {
                id: 'total-menus-today',
                title: t('menuGenerator.table.top10.stats.label.totalMenusToday'),
                value: t('menuGenerator.table.top10.stats.values.totalMenusToday', {
                    totalMenusToday: stats === null || stats === void 0 ? void 0 : stats.total_menu_sent_today,
                }),
            },
        ] }));
};
